'use strict';

import {
  gtmEventName,
  gtmCategoryName,
  gtmActionName,
  gtmCustomEvent,
  pushOnDataLayer,
  gtmLaunchViewCart
} from '@jspartials/gtm-utils';
import { listenDOMEvent } from '@jspartials/dom-api-utils';

// Classes
const BUTTON_SHOW_SITE_SELECTOR_CLASSNAME = 'gtm-button-show-site-selector';
const BUTTON_ACCESS_ACCOUNT_CLASSNAME = 'gtm-button-access-account';
const BUTTON_SOCIAL_LOGIN_GOOGLE_CLASSNAME = 'gtm-button-social-login-google';
const BUTTON_SOCIAL_LOGIN_FACEBOOK_CLASSNAME =
  'gtm-button-social-login-facebook';
const BUTTON_LOGIN_CLASSNAME = 'gtm-button-login';
const LINK_FORGOT_PASSWORD_CLASSNAME = 'gtm-link-forgot-password';
const BUTTON_GO_SIGNUP_CLASSNAME = 'gtm-button-go-signup';
const BUTTON_SIGNUP_CLASSNAME = 'gtm-button-signup';
const BUTTON_GO_LOGIN_CLASSNAME = 'gtm-button-go-login';
const CHECKBOX_LOGIN_REMEMBER_ME_CLASSNAME = 'gtm-checkbox-login-remember-me';
const CHECKBOX_SIGNUP_ACCEPTANCE_TERMS_AND_CONDITIONS_CLASSNAME =
  'gtm-checkbox-signup-acceptance-of-terms-and-conditions';
const CHECKBOX_SIGNUP_ACCEPTANCE_DATA_TREATMENT_CLASSNAME =
  'gtm-checkbox-signup-acceptance-data-treatment';
const BUTTON_SUBMIT_FORM_PASSWORD_RESET_CLASSNAME =
  'gtm-button-submit-form-password-reset';
const BUTTON_GO_LOGIN_FROM_PASSWORD_RESET_FORM_CLASSNAME =
  'gtm-button-go-login-from-password-reset-form';
const BUTTON_SOCIAL_SIGNUP_GOOGLE_CLASSNAME = 'gtm-button-social-signup-google';
const BUTTON_SOCIAL_SIGNUP_FACEBOOK_CLASSNAME =
  'gtm-button-social-signup-facebook';
const BUTTON_SUBMIT_FORM_WELCOME_PAGE_ACCOUNT_CLASSNAME =
  'gtm-button-submit-form-welcome-page-account';
const BUTTON_SKIP_FORM_WELCOME_PAGE_ACCOUNT_CLASSNAME =
  'gtm-button-skip-form-welcome-page-account';
const BUTTON_MENU_ACCOUNT_CLASSNAME = 'gtm-button-menu-account';
const CUSTOMER_AREA_PAGE_CLASSNAME = 'gtm-customer-area-page';

// Selectors
const BUTTON_SHOW_SITE_SELECTOR_SELECTOR = `.${BUTTON_SHOW_SITE_SELECTOR_CLASSNAME}`;
const BUTTON_ACCESS_ACCOUNT_SELECTOR = `.${BUTTON_ACCESS_ACCOUNT_CLASSNAME}`;
const BUTTON_SOCIAL_LOGIN_GOOGLE_SELECTOR = `.${BUTTON_SOCIAL_LOGIN_GOOGLE_CLASSNAME}`;
const BUTTON_SOCIAL_LOGIN_FACEBOOK_SELECTOR = `.${BUTTON_SOCIAL_LOGIN_FACEBOOK_CLASSNAME}`;
const BUTTON_LOGIN_SELECTOR = `.${BUTTON_LOGIN_CLASSNAME}`;
const LINK_FORGOT_PASSWORD_SELECTOR = `.${LINK_FORGOT_PASSWORD_CLASSNAME}`;
const BUTTON_GO_SIGNUP_SELECTOR = `.${BUTTON_GO_SIGNUP_CLASSNAME}`;
const BUTTON_SIGNUP_SELECTOR = `.${BUTTON_SIGNUP_CLASSNAME}`;
const BUTTON_GO_LOGIN_SELECTOR = `.${BUTTON_GO_LOGIN_CLASSNAME}`;
const CHECKBOX_LOGIN_REMEMBER_ME_SELECTOR = `.${CHECKBOX_LOGIN_REMEMBER_ME_CLASSNAME}`;
const CHECKBOX_SIGNUP_ACCEPTANCE_TERMS_AND_CONDITIONS_SELECTOR = `.${CHECKBOX_SIGNUP_ACCEPTANCE_TERMS_AND_CONDITIONS_CLASSNAME}`;
const CHECKBOX_SIGNUP_ACCEPTANCE_DATA_TREATMENT_SELECTOR = `.${CHECKBOX_SIGNUP_ACCEPTANCE_DATA_TREATMENT_CLASSNAME}`;
const BUTTON_SUBMIT_FORM_PASSWORD_RESET_SELECTOR = `.${BUTTON_SUBMIT_FORM_PASSWORD_RESET_CLASSNAME}`;
const BUTTON_GO_LOGIN_FROM_PASSWORD_RESET_FORM_SELECTOR = `.${BUTTON_GO_LOGIN_FROM_PASSWORD_RESET_FORM_CLASSNAME}`;
const BUTTON_SOCIAL_SIGNUP_GOOGLE_SELECTOR = `.${BUTTON_SOCIAL_SIGNUP_GOOGLE_CLASSNAME}`;
const BUTTON_SOCIAL_SIGNUP_FACEBOOK_SELECTOR = `.${BUTTON_SOCIAL_SIGNUP_FACEBOOK_CLASSNAME}`;
const BUTTON_SUBMIT_FORM_WELCOME_PAGE_ACCOUNT_SELECTOR = `.${BUTTON_SUBMIT_FORM_WELCOME_PAGE_ACCOUNT_CLASSNAME}`;
const BUTTON_SKIP_FORM_WELCOME_PAGE_ACCOUNT_SELECTOR = `.${BUTTON_SKIP_FORM_WELCOME_PAGE_ACCOUNT_CLASSNAME}`;
const BUTTON_MENU_ACCOUNT_SELECTOR = `.${BUTTON_MENU_ACCOUNT_CLASSNAME}`;
const CUSTOMER_AREA_PAGE_SELECTOR = `.${CUSTOMER_AREA_PAGE_CLASSNAME}`;

// Elements
const buttonsShowSiteSelector = document.querySelectorAll(
  BUTTON_SHOW_SITE_SELECTOR_SELECTOR
);
const buttonAccessAccount = document.querySelector(
  BUTTON_ACCESS_ACCOUNT_SELECTOR
);
const buttonSocialLoginGoogle = document.querySelector(
  BUTTON_SOCIAL_LOGIN_GOOGLE_SELECTOR
);
const buttonSocialLoginFacebook = document.querySelector(
  BUTTON_SOCIAL_LOGIN_FACEBOOK_SELECTOR
);
const buttonLogin = document.querySelector(BUTTON_LOGIN_SELECTOR);
const linkForgotPassword = document.querySelector(
  LINK_FORGOT_PASSWORD_SELECTOR
);
const buttonGoSignup = document.querySelector(BUTTON_GO_SIGNUP_SELECTOR);
const buttonSignup = document.querySelector(BUTTON_SIGNUP_SELECTOR);
const buttonGoLogin = document.querySelector(BUTTON_GO_LOGIN_SELECTOR);
const checkboxLoginRememberMe = document.querySelector(
  CHECKBOX_LOGIN_REMEMBER_ME_SELECTOR
);
const checkboxSignupAcceptanceTermsAndConditions = document.querySelector(
  CHECKBOX_SIGNUP_ACCEPTANCE_TERMS_AND_CONDITIONS_SELECTOR
);
const checkboxSignupAcceptanceDataTreatment = document.querySelector(
  CHECKBOX_SIGNUP_ACCEPTANCE_DATA_TREATMENT_SELECTOR
);
const buttonSubmitFormPasswordReset = document.querySelector(
  BUTTON_SUBMIT_FORM_PASSWORD_RESET_SELECTOR
);
const buttonGoLoginFromPasswordResetForm = document.querySelector(
  BUTTON_GO_LOGIN_FROM_PASSWORD_RESET_FORM_SELECTOR
);
const buttonSocialSignupGoogle = document.querySelector(
  BUTTON_SOCIAL_SIGNUP_GOOGLE_SELECTOR
);
const buttonSocialSignupFacebook = document.querySelector(
  BUTTON_SOCIAL_SIGNUP_FACEBOOK_SELECTOR
);
const buttonSubmitFormWelcomePageAccount = document.querySelector(
  BUTTON_SUBMIT_FORM_WELCOME_PAGE_ACCOUNT_SELECTOR
);
const buttonSkipFormWelcomePageAccount = document.querySelector(
  BUTTON_SKIP_FORM_WELCOME_PAGE_ACCOUNT_SELECTOR
);
const buttonsMenuAccount = document.querySelectorAll(
  BUTTON_MENU_ACCOUNT_SELECTOR
);
const customerAreaPage = document.querySelector(CUSTOMER_AREA_PAGE_SELECTOR);

// Selectors
const selector = {
  header: {
    menu: {
      link: '[gtm-header-menu-link]',
      list: {
        item: '[gtm-header-menu-list-item]'
      }
    },
    submenu: {
      link: '[gtm-header-submenu-link]'
    },
    cart: {
      link: '[gtm-header-cart-link]',
      quantity: '[gtm-header-cart-quantity]'
    },
    logo: '[gtm-header-logo]'
  },
  siteSelector: {
    wrapper: '[gtm-site-selector-wrapper]',
    currentOptionSelected: '[gtm-site-selector-current-option-selected]',
    button: {
      confirm: '[gtm-site-selector-button-confirm]'
    }
  },
  footer: {
    link: '[gtm-footer-link]',
    linkSocial: '[gtm-footer-link-social]'
  },
  page: {
    cart: '.js-cart-page'
  }
};

// Elements
const element = {
  header: {
    menu: {
      link: document.querySelectorAll(selector.header.menu.link) || []
    },
    submenu: {
      link: document.querySelectorAll(selector.header.submenu.link) || []
    },
    cart: {
      link: document.querySelector(selector.header.cart.link) || null
    },
    logo: document.querySelector(selector.header.logo) || null
  },
  siteSelector: {
    wrapper: document.querySelector(selector.siteSelector.wrapper) || null,
    button: {
      confirm:
        document.querySelector(selector.siteSelector.button.confirm) || null
    }
  },
  footer: {
    link: document.querySelectorAll(selector.footer.link) || [],
    linkSocial: document.querySelectorAll(selector.footer.linkSocial) || []
  },
  page: {
    cart: document.querySelector(selector.page.cart) || null
  }
};

// Variables
const urlGtmViewCart = globalVariables?.endpoint?.gtmViewCart || null;

/******************************************************************************
 * NEW EVENTS
 *****************************************************************************/

// View cart
if (element.page.cart && urlGtmViewCart) {
  gtmLaunchViewCart(urlGtmViewCart);
}

// After login
if (customerAreaPage) {
  listenDOMEvent(customerAreaPage, gtmCustomEvent.afterLogin, (event) => {
    const customer = event.detail.customer;

    if (customer) {
      pushOnDataLayer({
        customer: customer
      });
    }
  });

  // Previously logged socially (by Facebook or Google)
  customerAreaPage.addEventListener(
    gtmCustomEvent.previousLoggedSocially,
    (event) => {
      const provider = event.detail.provider;
      const label = provider
        ? `Login URL | Regular Login | Log In Error | Social Login | Log In ${provider}`
        : false;

      if (label) {
        pushOnDataLayer({
          event: gtmEventName.eventTracking,
          category: gtmCategoryName.login,
          action: gtmActionName.view,
          label: label
        });
      }
    }
  );
}

// Show site selector
if (buttonsShowSiteSelector) {
  buttonsShowSiteSelector.forEach((button) => {
    listenDOMEvent(button, 'mouseenter', () => {
      const label = `Top Menu | version selector`;

      const dataLayerInfo = {
        event: gtmEventName.eventTracking,
        category: gtmCategoryName.header,
        action: gtmActionName.click,
        label: label
      };

      pushOnDataLayer(dataLayerInfo);
    });
  });
}

// Access to the customer account
if (buttonAccessAccount) {
  listenDOMEvent(buttonAccessAccount, 'click', () => {
    const label = `Top Menu | UserLogin`;

    const dataLayerInfo = {
      event: gtmEventName.eventTracking,
      category: gtmCategoryName.header,
      action: gtmActionName.click,
      label: label
    };

    pushOnDataLayer(dataLayerInfo);
  });
}

// Social login with Google
if (buttonSocialLoginGoogle) {
  listenDOMEvent(buttonSocialLoginGoogle, 'click', () => {
    const label = `Login URL | Social Login | Log In Google`;

    const dataLayerInfo = {
      event: gtmEventName.eventTracking,
      category: gtmCategoryName.login,
      action: gtmActionName.click,
      label: label
    };

    pushOnDataLayer(dataLayerInfo);
  });
}

// Social login with Facebook
if (buttonSocialLoginFacebook) {
  listenDOMEvent(buttonSocialLoginFacebook, 'click', () => {
    const label = `Login URL | Social Login | Log In Facebook`;

    const dataLayerInfo = {
      event: gtmEventName.eventTracking,
      category: gtmCategoryName.login,
      action: gtmActionName.click,
      label: label
    };

    pushOnDataLayer(dataLayerInfo);
  });
}

// Regular login
if (buttonLogin) {
  listenDOMEvent(buttonLogin, 'click', () => {
    const label = `Login URL | Regular Login | Log In`;

    const dataLayerInfo = {
      event: gtmEventName.eventTracking,
      category: gtmCategoryName.login,
      action: gtmActionName.click,
      label: label
    };

    pushOnDataLayer(dataLayerInfo);
  });
}

// Forgot password
if (linkForgotPassword) {
  listenDOMEvent(linkForgotPassword, 'click', () => {
    const label = `Login URL | Regular Login | Forgot Password`;

    const dataLayerInfo = {
      event: gtmEventName.eventTracking,
      category: gtmCategoryName.login,
      action: gtmActionName.click,
      label: label
    };

    pushOnDataLayer(dataLayerInfo);
  });
}

// Go to signup
if (buttonGoSignup) {
  listenDOMEvent(buttonGoSignup, 'click', () => {
    const label = `Login URL | Regular Login | No Account`;

    const dataLayerInfo = {
      event: gtmEventName.eventTracking,
      category: gtmCategoryName.login,
      action: gtmActionName.click,
      label: label
    };

    pushOnDataLayer(dataLayerInfo);
  });
}

// Signup
if (buttonSignup) {
  listenDOMEvent(buttonSignup, 'click', () => {
    const label = `Login URL | Create Regular Login | Register`;

    const dataLayerInfo = {
      event: gtmEventName.eventTracking,
      category: gtmCategoryName.login,
      action: gtmActionName.click,
      label: label
    };

    pushOnDataLayer(dataLayerInfo);
  });
}

// Go to login
if (buttonGoLogin) {
  listenDOMEvent(buttonGoLogin, 'click', () => {
    const label = `Login URL | Create Regular Login | Log In`;

    const dataLayerInfo = {
      event: gtmEventName.eventTracking,
      category: gtmCategoryName.login,
      action: gtmActionName.click,
      label: label
    };

    pushOnDataLayer(dataLayerInfo);
  });
}

// Remember me (login)
if (checkboxLoginRememberMe) {
  listenDOMEvent(checkboxLoginRememberMe, 'click', () => {
    if (checkboxLoginRememberMe.checked) {
      const label = `Login URL | Regular Login | Login Remember Me`;

      const dataLayerInfo = {
        event: gtmEventName.eventTracking,
        category: gtmCategoryName.login,
        action: gtmActionName.click,
        label: label
      };

      pushOnDataLayer(dataLayerInfo);
    }
  });
}

// Acceptance of terms and conditions (signup)
if (checkboxSignupAcceptanceTermsAndConditions) {
  listenDOMEvent(checkboxSignupAcceptanceTermsAndConditions, 'click', () => {
    if (checkboxSignupAcceptanceTermsAndConditions.checked) {
      const label = `Login URL | Create Regular Login | Accept Terms`;

      const dataLayerInfo = {
        event: gtmEventName.eventTracking,
        category: gtmCategoryName.login,
        action: gtmActionName.click,
        label: label
      };

      pushOnDataLayer(dataLayerInfo);
    }
  });
}

// Acceptance data treatment (signup)
if (checkboxSignupAcceptanceDataTreatment) {
  listenDOMEvent(checkboxSignupAcceptanceDataTreatment, 'click', () => {
    if (checkboxSignupAcceptanceDataTreatment.checked) {
      const label = `Login URL | Create Regular Login | Authorise Processing Data`;

      const dataLayerInfo = {
        event: gtmEventName.eventTracking,
        category: gtmCategoryName.login,
        action: gtmActionName.click,
        label: label
      };

      pushOnDataLayer(dataLayerInfo);
    }
  });
}

// Submit form (password reset)
if (buttonSubmitFormPasswordReset) {
  listenDOMEvent(buttonSubmitFormPasswordReset, 'click', () => {
    const label = `Login URL | Regular Login | Login Recover Password`;

    const dataLayerInfo = {
      event: gtmEventName.eventTracking,
      category: gtmCategoryName.login,
      action: gtmActionName.click,
      label: label
    };

    pushOnDataLayer(dataLayerInfo);
  });
}

// Go to login (password reset form)
if (buttonGoLoginFromPasswordResetForm) {
  listenDOMEvent(buttonGoLoginFromPasswordResetForm, 'click', () => {
    const label = `Login URL | Regular Login | Login Recover Password | Link Sent | Login`;

    const dataLayerInfo = {
      event: gtmEventName.eventTracking,
      category: gtmCategoryName.login,
      action: gtmActionName.click,
      label: label
    };

    pushOnDataLayer(dataLayerInfo);
  });
}

// Social signup with Google
if (buttonSocialSignupGoogle) {
  listenDOMEvent(buttonSocialSignupGoogle, 'click', () => {
    const label = `Login URL | Create Social Login | Google`;

    const dataLayerInfo = {
      event: gtmEventName.eventTracking,
      category: gtmCategoryName.login,
      action: gtmActionName.click,
      label: label
    };

    pushOnDataLayer(dataLayerInfo);
  });
}

// Social signup with Facebook
if (buttonSocialSignupFacebook) {
  listenDOMEvent(buttonSocialSignupFacebook, 'click', () => {
    const label = `Login URL | Create Social Login | Facebook`;

    const dataLayerInfo = {
      event: gtmEventName.eventTracking,
      category: gtmCategoryName.login,
      action: gtmActionName.click,
      label: label
    };

    pushOnDataLayer(dataLayerInfo);
  });
}

// Submit form (welcome page account)
if (buttonSubmitFormWelcomePageAccount) {
  listenDOMEvent(buttonSubmitFormWelcomePageAccount, 'click', () => {
    const label = `UserArea | Welcome | Save`;

    const dataLayerInfo = {
      event: gtmEventName.eventTracking,
      category: gtmCategoryName.account,
      action: gtmActionName.click,
      label: label
    };

    pushOnDataLayer(dataLayerInfo);
  });
}

// Skip form (welcome page account)
if (buttonSkipFormWelcomePageAccount) {
  listenDOMEvent(buttonSkipFormWelcomePageAccount, 'click', () => {
    const label = `UserArea | Welcome | Skip Step`;

    const dataLayerInfo = {
      event: gtmEventName.eventTracking,
      category: gtmCategoryName.account,
      action: gtmActionName.click,
      label: label
    };

    pushOnDataLayer(dataLayerInfo);
  });
}

// Menu (account)
if (buttonsMenuAccount.length > 0) {
  buttonsMenuAccount.forEach((button) => {
    listenDOMEvent(button, 'click', () => {
      const label = `UserArea | Personal Data | ${button.dataset.gtmTitle}`;

      const dataLayerInfo = {
        event: gtmEventName.eventTracking,
        category: gtmCategoryName.account,
        action: gtmActionName.click,
        label: label
      };

      pushOnDataLayer(dataLayerInfo);
    });
  });
}

// Click on menu link (header)
if (element.header.menu.link.length > 0) {
  element.header.menu.link.forEach((link) => {
    listenDOMEvent(link, 'click', () => {
      const label = `Top Menu | ${link.getAttribute('title')}`;

      const dataLayerInfo = {
        event: gtmEventName.eventTracking,
        category: gtmCategoryName.header,
        action: gtmActionName.click,
        label: label
      };

      pushOnDataLayer(dataLayerInfo);
    });
  });
}

// Click on submenu link (header)
if (element.header.submenu.link.length > 0) {
  element.header.submenu.link.forEach((link) => {
    listenDOMEvent(link, 'click', () => {
      const parent = link.closest(selector.header.menu.list.item) || null;
      const linkParent = parent
        ? parent.querySelector(selector.header.menu.link)
        : null;
      const titleParent = linkParent ? linkParent.getAttribute('title') : '';
      const title = link.getAttribute('title');
      const label = titleParent
        ? `Top Menu | ${titleParent} | ${title}`
        : `Top Menu | ${title}`;

      const dataLayerInfo = {
        event: gtmEventName.eventTracking,
        category: gtmCategoryName.header,
        action: gtmActionName.click,
        label: label
      };

      pushOnDataLayer(dataLayerInfo);
    });
  });
}

// Click on cart link (header)
if (element.header.cart.link) {
  listenDOMEvent(element.header.cart.link, 'click', () => {
    const cartQuantityElement =
      element.header.cart.link.querySelector(selector.header.cart.quantity) ||
      null;
    const totalItemsInCart = cartQuantityElement
      ? cartQuantityElement.textContent
      : '';
    const label = `Basket | ${totalItemsInCart}`;

    const dataLayerInfo = {
      event: gtmEventName.eventTracking,
      category: gtmCategoryName.header,
      action: gtmActionName.click,
      label: label
    };

    pushOnDataLayer(dataLayerInfo);
  });
}

// Show site selector after load page
if (element.siteSelector.wrapper) {
  const siteSelectorCurrentOptionSelectedElement =
    element.siteSelector.wrapper.querySelector(
      selector.siteSelector.currentOptionSelected
    ) || null;
  const siteSelectorCurrentOptionSelectedInitially =
    siteSelectorCurrentOptionSelectedElement
      ? siteSelectorCurrentOptionSelectedElement.dataset.locale
      : '';
  const dataLayerInfo = {
    event: gtmEventName.eventTracking,
    category: gtmCategoryName.header,
    action: gtmActionName.view,
    label: `version selector | ${siteSelectorCurrentOptionSelectedInitially}`
  };

  pushOnDataLayer(dataLayerInfo);
}

// Confirm locale in site selector
if (element.siteSelector.button.confirm) {
  listenDOMEvent(element.siteSelector.button.confirm, 'click', () => {
    const siteSelectorCurrentOptionSelectedElement =
      element.siteSelector.wrapper.querySelector(
        selector.siteSelector.currentOptionSelected
      ) || null;
    const siteSelectorCurrentOptionSelected =
      siteSelectorCurrentOptionSelectedElement
        ? siteSelectorCurrentOptionSelectedElement.dataset.locale
        : '';
    const dataLayerInfo = {
      event: gtmEventName.eventTracking,
      category: gtmCategoryName.header,
      action: gtmActionName.click,
      label: `version selector | ${siteSelectorCurrentOptionSelected}`
    };

    pushOnDataLayer(dataLayerInfo);
  });
}

// Click on logo (header)
if (element.header.logo) {
  listenDOMEvent(element.header.logo, 'click', () => {
    const dataLayerInfo = {
      event: gtmEventName.eventTracking,
      category: gtmCategoryName.header,
      action: gtmActionName.click,
      label: 'Logo'
    };

    pushOnDataLayer(dataLayerInfo);
  });
}

// Click on link (footer)
if (element.footer.link.length > 0) {
  element.footer.link.forEach((link) => {
    listenDOMEvent(link, 'click', () => {
      const dataLayerInfo = {
        event: gtmEventName.eventTracking,
        category: gtmCategoryName.footer,
        action: gtmActionName.click,
        label: link.textContent.trim()
      };

      pushOnDataLayer(dataLayerInfo);
    });
  });
}

// Click on social link (footer)
if (element.footer.linkSocial.length > 0) {
  element.footer.linkSocial.forEach((link) => {
    listenDOMEvent(link, 'click', () => {
      const label = `Social | ${link.getAttribute('title')}`;
      const dataLayerInfo = {
        event: gtmEventName.eventTracking,
        category: gtmCategoryName.footer,
        action: gtmActionName.click,
        label: label
      };

      pushOnDataLayer(dataLayerInfo);
    });
  });
}

// TODO: REFACTORIZE please!!

// 23 Product options modal - step 1
$('body').on('click', '.add-to-cart[data-has-options="true"]', function (e) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'eventTracking',
    category: 'PDP Eyewear',
    action: 'Click',
    label: 'SELECT LENSES AND PURCHASE'
  });
});

// 24 Product options modal - step 1
$('body').on(
  'click',
  '#productOptionsModal [data-step-id="1"] .option-value-container',
  function (e) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'eventTracking',
      category: 'PDP Eyewear',
      action: $(this).attr('data-value-id'),
      label: 'Lens type'
    });
  }
);

// 25 Product options modal - step 2
$('body').on(
  'click',
  '#productOptionsModal [data-step-id="2"] .option-value-container',
  function (e) {
    window.dataLayer = window.dataLayer || [];
    var step1Value = $(this)
      .parents('[data-step-id]')
      .siblings('[data-step-id="1"]')
      .find('.selected')
      .attr('data-value-id');
    var action = $(this).attr('data-value-id');
    if (typeof step1Value !== 'undefined') {
      action = action + ' ' + step1Value;
    }
    window.dataLayer.push({
      event: 'eventTracking',
      category: 'PDP Eyewear',
      action: action,
      label: 'Lens Color'
    });
  }
);

// 26 Product options modal - step 3
$('body').on(
  'click',
  '#productOptionsModal [data-step-id="3"] .option-value-container',
  function (e) {
    window.dataLayer = window.dataLayer || [];
    var step1Value = $(this)
      .parents('[data-step-id]')
      .siblings('[data-step-id="1"]')
      .find('.selected')
      .attr('data-value-id');
    var step2Value = $(this)
      .parents('[data-step-id]')
      .siblings('[data-step-id="2"]')
      .find('.selected')
      .attr('data-value-id');
    var action = $(this).attr('data-value-id');
    if (typeof step1Value !== 'undefined') {
      action = action + ' ' + step1Value;
    }
    if (typeof step2Value !== 'undefined') {
      action = action + ' ' + step2Value;
    }
    window.dataLayer.push({
      event: 'eventTracking',
      category: 'PDP Eyewear',
      action: action,
      label: 'Treatment'
    });
  }
);
